export class NetworkError extends Error {
  constructor(
    message: string,
    public response?: Response
  ) {
    super(message);
    this.name = 'NetworkError';
  }
}

export class HttpClient {
  private static async fetch(url: string, options?: RequestInit): Promise<Response> {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new NetworkError(`HTTP error! Status: ${response.status}`, response);
    }

    return response;
  }

  static async get(url: string, options?: RequestInit): Promise<Response> {
    return HttpClient.fetch(url, { ...options, method: 'GET' });
  }

  static async post(url: string, body: any, options?: RequestInit): Promise<Response> {
    return HttpClient.fetch(url, { ...options, method: 'POST', body });
  }
}
